module.exports = __webpack_public_path__ + "img/estimate-icon.a930ee00.svg";